import { AiOutlineDislike, AiOutlineLike } from "react-icons/ai";
import React, { useContext, useMemo } from "react";
import styles from "./index.module.scss";
import { Button, message } from "antd";
import { DiscussContent } from "../../context";
import className from "classnames";
import {
    dislikeOrCancel,
    likeOrCancel,
    ReplyItemData
} from "../../../../../API/discuss";
import useRequestFn from "../../../../../Utils/useRequestFn";
import { errorMessage } from "../../../../../Utils/useRequest";
import { isTrue } from "../../../../../Utils/filter";

interface LikeOrNotProps {
    answerData: ReplyItemData;
}

export function LikeOrNot({ answerData }: LikeOrNotProps) {
    const { updateDiscussDetail, isDead, discussDetail } =
        useContext(DiscussContent);
    const studentNo = localStorage.getItem("STUDENTNO");

    const { topicUuid, uuid } = answerData;

    function findInList(list?: { type: string; no: string }[]) {
        if (!list) return false;
        return !!list.find(item => item.no === studentNo);
    }

    // 点过赞
    const liked = useMemo(() => findInList(answerData.likes), [answerData]);

    // 点过踩
    const disLiked = useMemo(
        () => findInList(answerData.dislikes),
        [answerData]
    );

    const [onLike, likeStatus] = useRequestFn(async () => {
        if (isDead) {
            return message.warning("已经截止");
        }
        try {
            await likeOrCancel(topicUuid, uuid);
            await updateDiscussDetail();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    const [onDisLike, disLikeStatus] = useRequestFn(async () => {
        if (isDead) {
            return message.warning("已经截止");
        }
        try {
            await dislikeOrCancel(topicUuid, uuid);
            await updateDiscussDetail();
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    const isLoading = likeStatus.loading || disLikeStatus.loading;

    return (
        <>
            {isTrue(discussDetail?.showLike) && (
                <Button
                    className={className(styles.btnLike, {
                        [styles.btnOn]: liked
                    })}
                    title="赞同"
                    onClick={onLike}
                    disabled={disLiked || isLoading}>
                    <AiOutlineLike /> {answerData.likeCount || 0}
                </Button>
            )}
            {isTrue(discussDetail?.showDislike) && (
                <Button
                    className={className(styles.btnDisLike, {
                        [styles.btnOn]: disLiked
                    })}
                    title="反对"
                    onClick={onDisLike}
                    disabled={liked || isLoading}>
                    <AiOutlineDislike /> {answerData.dislikeCount || 0}
                </Button>
            )}
        </>
    );
}
